import React from 'react'
import moment from 'moment'

// graphql
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

const STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export default function RequestInfo({ requestId }) {

    let request = {
        job: {

        },
        truck: {

        }
    }

    const { data } = useQuery(GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, {
        variables: { id: requestId }
    })

    if(data && data.equipmentRequest) {
        request = {
            ...data.equipmentRequest,
            datetimeRequested: moment(data.equipmentRequest.datetimeCreated).isValid() ? moment(data.equipmentRequest.datetimeCreated).format("MM/DD/YYYY") : null,
            status: STATUS_CHOICES[data.equipmentRequest.status],
            datetimeFulfilled: moment(data.equipmentRequest.datetimeFulfilled).isValid() ? moment(data.equipmentRequest.datetimeFulfilled).format("MM/DD/YYYY") : null,
        }
    }

    return (<Card header={{ icon: null, title: 'Info'}}>
        
        <CardDataPoint label='Job' value={request.job.name} />
        <CardDataPoint label='Date Requested' value={request.datetimeRequested} />
        <CardDataPoint label='Status' value={request.status} />
        <CardDataPoint label='Date Fulfilled' value={request.datetimeFulfilled} />
        <CardDataPoint label='Truck' value={request.truck ? request.truck.number : null} />
        <CardDataPoint label='Notes' value={request.notes} />

    </Card>)
}